import { isFuture, differenceInDays } from 'date-fns';

// eslint-disable no-underscore-dangle

interface IntercomIdentifyData {
  id: string;
  name: string;
  email: string;
  isPaid: boolean;
  currentPlan: string;
  trialEndsAt: string;
  couponCode: string | null;
  intercomIdentityVerificationHash: string;
  language: string;
}

export const identify = (data: IntercomIdentifyData) => {
  if ((window as any).Intercom) {
    try {
      const APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;
      (window as any).Intercom('boot', {
        app_id: APP_ID,
        user_id: data.id,
        user_hash: data.intercomIdentityVerificationHash,
        language_override: data.language,
        name: data.name,
        email: data.email,
        is_paid: data.isPaid,
        currentPlan: data.currentPlan,
        on_trial: isFuture(data.trialEndsAt),
        trial_days_remaining: differenceInDays(data.trialEndsAt, new Date()),
        coupon_code: data.couponCode,
        custom_launcher_selector: '.live-chat',
      });
      (window as any).Intercom('update', {
        hide_default_launcher: true,
      });
    } catch (error) {
      console.error(error);
    }
  }
};

export const show = () => {
  if ((window as any).Intercom) {
    (window as any).Intercom('boot');
  }
};

// eslint-enable no-underscore-dangle
